/* src/app/components/dialogs/manual-upload/manual-upload.component.scss */
mat-dialog-content {
  margin: 24px;
  min-width: 200px;
  min-height: 50px;
}
/*# sourceMappingURL=manual-upload.component.css.map */
